import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
  width: 100%;
  padding: 1rem;
  max-width: 14.875rem;

  gap: 1rem;
  display: flex;  
  flex-direction: column;

  border-radius: 1rem;
  background-color: #F8F8F9;

  @media (max-width: 790px) {
    max-width: 100%;

    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
  }
 
  @media (max-width: 767px) {
    margin-bottom: 0;
    background-color: transparent;
  }
`;

export const CustomSelect = styled.div`
  position: relative;

  max-height: 2rem;
  width: 100%;
  max-width: 12.25rem;

  @media (max-width: 756px) {
    max-width: 100%;
    max-height: none;
  }
`;

export const SelectButton = styled.div`
  height: 32px;
  padding: 8.5px 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;
  user-select: none;
  border-radius: 1.25rem;
  background: ${(props) => (props.selected ? "#21262F" : "#F8F8F9")};
  border: 1px solid ${theme.colors.gray.Cinza_2};

  color: ${(props) => (props.selected ? "#FFF" : "#21262F")};

  >p{
    white-space: nowrap;
  }

  @media (max-width: 756px) {
    height: 40px;
    background: ${(props) => (props.selected ? "#21262F" : "transparent")};
  }
`;

export const Arrow = styled.div`
  width: 16px;
  height: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: transform 0.3s;

  &.open {
    transform: rotate(180deg);
  }

  img {
    filter: ${(props) => (props.selected ? "invert(1)" : "invert(0)")};
  }
`;


export const SelectOptions = styled.div`
  top: 110%;
  z-index: 1;
  position: absolute;
  
  width: 196px;
  max-height: 15rem;
  
  overflow-y: auto;

  display: flex;
  flex-direction: column;

  background: white;
  border-radius: 0.625rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

    @media (max-width: 760px) {
      position: relative;

      top: 0;
      width: 100%;
    }
`;

export const SearchInputContainer = styled.div`
  width: 100%;
  padding: 0.625rem;
  border-bottom: 1px solid #eee;

  input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #E0E0E0;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    color: ${theme.colors.gray.Cinza_2};
    outline: none;
  }
`;

export const OptionsList = styled.div`
  max-height: 15rem;
  overflow-y: auto;
  
  ::-webkit-scrollbar {
        width: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888; 
        border-radius: 8px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }

    @media (max-width: 760px) {
      position: relative;

      top: 0;
      width: 100%;
      max-height: 9rem;
    }
`;

export const Option = styled.div`
  padding: 0.625rem;

  display: flex;
  align-items: center;
  
  cursor: pointer;
  font-size: 0.8rem;
  
  transition: 0.3s;
  
  &:hover {
    background: #eee;
  }

  input {
    margin-right: 8px;
    cursor: pointer;
  }
`;

export const ContainerSwitch = styled.div`
  width: 100%;
  height: 30px;

  gap: 8px;
  display: flex;
  align-items: center;
  margin-left: 0.3rem;

  @media (max-width: 790px) {
    margin-left: 0;
    justify-content: center;
  }
`;

export const SwitchContainer = styled.div`
  position: relative;

  width: 30px;
  height: 12px;
  padding: 0.125rem;
  
  display: flex;
  align-items: center;
  
  cursor: pointer;
  border-radius: 0.625rem;
  border: ${({ isActive }) => (isActive ? "none" : `1px solid  ${theme.colors.gray.Cinza_8}`)};
  background-color: ${({ isActive }) => (isActive ? "#2FBB693D" : theme.colors.gray.Cinza_12)};
`;

export const SwitchCircle = styled.div`
  width: 18px;
  height: 18px;
  left: ${({ isActive }) => (isActive ? "0.7rem" : "-0.25rem")};
    
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  transition: left 0.3s ease;
  
  border: ${({ isActive }) => (isActive ? "none" : `1px solid ${theme.colors.gray.Cinza_8}`)};
  background: ${({ isActive }) => (isActive ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_10)};
`;